
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { MapPin, Shield } from "lucide-react";

interface ProfileAddressSectionProps {
  formData: {
    address: string;
    additional_info: string;
  };
  onInputChange: (field: string, value: string) => void;
  loading: boolean;
}

export const ProfileAddressSection = ({ 
  formData, 
  onInputChange, 
  loading 
}: ProfileAddressSectionProps) => {
  return (
    <Card className="mb-6 bg-carbon border-ice-white/10">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-ice-white">
          <MapPin className="w-5 h-5 text-neon-red" />
          Address
        </CardTitle>
        <CardDescription className="flex items-start gap-2 text-ice-white/70">
          <Shield className="w-4 h-4 text-toxic-green mt-0.5 flex-shrink-0" />
          <div>
            <strong>Alpha, safety first!</strong>
            <br />
            We are the first app to enable you sending the address to your partner exactly for the time that he needs it. After 60 minutes the other user has no access to the address anymore. No more address stays in the chat for eternity.
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-ice-white mb-2">
            Address
          </label>
          <Input
            value={formData.address}
            onChange={(e) => onInputChange('address', e.target.value)}
            placeholder="e.g., Potsdamer Platz 5, 10785 Berlin"
            disabled={loading}
            className="bg-carbon border-ice-white/20 text-ice-white placeholder:text-ice-white/50"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-ice-white mb-2">
            Additional Information
          </label>
          <Textarea
            value={formData.additional_info}
            onChange={(e) => onInputChange('additional_info', e.target.value)}
            placeholder="Entry details, floor, doorbell, etc."
            rows={3}
            disabled={loading}
            className="bg-carbon border-ice-white/20 text-ice-white placeholder:text-ice-white/50"
          />
        </div>
      </CardContent>
    </Card>
  );
};
